import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const noticias = {
	state: {
        // programasDeLaEmpresa : '',
		// programasActivos : ''
	},
	getters: {
        // getProgramasDeLaEmpresa: state => state.programasDeLaEmpresa,
		// getProgramasActivos: state => state.programasActivos,
	},
	actions: {
		getActualidad({commit}, empresa){
			let url = ((!empresa)) ? '/api/Alumno/getActualidad' : '/api/Empresa/getActualidad';
			return new Promise((resolve, reject) => {
				axios.get(url).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		getNoticiaAlumno({commit}, idRecurso){
			let url = '/api/Alumno/getNoticia/';
			return new Promise((resolve, reject) => {
				axios.get(`${url}${idRecurso}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		getNoticiaEmpresa({commit}, idRecurso){
			let url = '/api/Empresa/getNoticia/';
			return new Promise((resolve, reject) => {
				axios.get(`${url}${idRecurso}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		getRecursos({commit}, empresa){
			let url = (!empresa) ? '/api/Alumno/getRecursosNoticias' : '/api/Empresa/getRecursosNoticias';
			return new Promise((resolve, reject) => {
				axios.get(url).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		getRecursoAlumno({commit}, idRecurso){
			let url = '/api/Alumno/getRecursoNoticia/';
			return new Promise((resolve, reject) => {
				axios.get(`${url}${idRecurso}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		getRecursoEmpresa({commit}, idRecurso){
			let url = '/api/Empresa/getRecursoNoticia/';
			return new Promise((resolve, reject) => {
				axios.get(`${url}${idRecurso}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
	},
	mutations: {
        // setProgramasDeLaEmpresa: function (state, data) {
		// 	data = Object.entries(data).sort(function (p1,p2) {
		// 		return (p1[1] < p2[1]) ? -1 : 1;
		// 	});
		// 	state.programasDeLaEmpresa = data;
		// },
		// setProgramasActivos: function (state, data) {
		// 	state.programasActivos = data;
		// }
	}
}

export default noticias;



// WEBPACK FOOTER //
// ./src/store/noticias.js